import React from 'react';
import Box from '@mui/material/Box';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';

export const BANNER_HEIGHT = 32;

export default function OfflineBanner({ isOnline, justReconnected }) {
  const visible = !isOnline || justReconnected;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: (theme) => theme.zIndex.appBar + 1,
        height: BANNER_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        backgroundColor: isOnline ? 'success.main' : '#444',
        color: '#fff',
        fontSize: '0.8rem',
        transition: 'transform 0.25s ease',
        transform: visible ? 'translateY(0)' : 'translateY(-100%)',
      }}
    >
      {isOnline ? <WifiIcon sx={{ fontSize: '1rem' }} /> : <WifiOffIcon sx={{ fontSize: '1rem' }} />}
      {isOnline ? 'Back online' : "You're offline"}
    </Box>
  );
}
